module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/78cd8e2c774b858b4e49077d0b1b391d.png";